import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DmcQuotesService } from 'src/app/business-service/dmc-quotes/dmc-quotes.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-dmc-quote-notes',
  templateUrl: './dmc-quote-notes.component.html',
  styleUrls: ['./dmc-quote-notes.component.scss'],
})
export class DmcQuoteNotesComponent implements OnInit {

  @Input() leadId: any;
  @Input() itineraryId: any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter();

  @Output() updateQuote: EventEmitter<void> = new EventEmitter();

  @Input() itineraryDetails: any;
  @Input() storedFormData: any;
  @Input() editQuote: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _dmcQuoteService: DmcQuotesService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
  ) { }

  notesForm!: FormGroup;

  async ngOnInit() {

    this.notesForm = this._fb.group({
      notes: [""]
    })

    this.notesForm.valueChanges.subscribe(() => {
      this.notesForm.markAsTouched();
    })

    if (this.storedFormData) {
      this.notesForm.patchValue({
        notes: this.storedFormData.note
      })
    }
  }

  async onSubmit(): Promise<boolean> {
    if (!this.notesForm.valid) {
      this.notesForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }

    try {
      const formData = await this.serializeFormData(this.notesForm.value);

      if (this.leadId) {
        // Handle lead-specific logic
        if (this.editQuote) {
          this.notesForm.markAsPristine();
          formData.dataSaved = true;
          this.storeFormData.emit(formData);
          this.updateQuote.emit();
        } else {
          await this._dmcQuoteService.addnotes(formData).toPromise();
          this._responseNotificationService.showMessage("Notes Added!");
          this.notesForm.markAsPristine();
          formData.dataSaved = true;
          this.storeFormData.emit(formData);
        }
      }

      return true; // Form submitted successfully
    } catch (error) {
      console.error("Error while submitting notes:", error);
      return false; // Submission failed
    }
  }


  private async serializeFormData(formData: any) {
    const serializedData = {
      leadId: this.leadId,
      itineraryId: this.itineraryId,
      note: formData.notes,
      organizationId: this.storedFormData?.organizationId,
      id: this.storedFormData ? this.storedFormData.id : null,
      createdBy: this.storedFormData ? this.storedFormData.createdBy : null,
      ...(this.storedFormData && { createDate: this.storedFormData.createDate })
    }

    return serializedData;
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    if (this.leadId) {
      this.viewChange.emit(false);
    }
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.notesForm.dirty || this.notesForm.invalid) && this.notesForm.touched;
  }

}
